<template>
	<div style="margin: 0 0 5px 0">
		<div style="width: 100%; height: 50px; background: #fff; margin: 0 0 1px 0;">
			<div style="display: flex; height: 100%; text-align: start; font-size: 16px; padding: 16px 0 12px 0">
				<div style="flex: 1; height: 14px; border-left: solid 4px #ff8a05; padding-left: 6px; font-weight: 600;">
					{{ payment.create_time.substring(0, 16) }}
				</div>
				<a @click="toEdit" style="margin-right: 16px" v-show="allowEdit">编辑</a>
			</div>
		</div>
		<div class="payment-item">
			<ul class="info-cont">
				<li v-if="!is_trans"><span class="label">付款方式</span><span>{{ payment.vendor_title }}</span></li>
				<li v-if="is_trans">
					<span class="label">付款方式</span><span>转账</span>
				</li>
				<li><span class="label">付款金额</span><span>{{ payment.amount }}元</span></li>
				<li><span class="label">付款日期</span><span>{{ paid_time }}</span></li>
				<li style="height: 24px; line-height: 24px;">
					<span class="label" style="padding: 0; vertical-align: middle;">付款状态</span><span :class="payStatusClass" style="display: inline-block; vertical-align: middle;">{{ payment.pay_status_title }}</span>
					<span v-if="this.payment.is_trans && payment.pay_status === 70" @click="toEdit" style="display: inline-flex; height: 24px; background: #459AFF; border-radius: 4px; align-items: center; vertical-align: middle; padding: 0 6px 0 4px; gap: 2px;">
						<span class="ic-pen-edit"></span>
						<span style="font-size: 13px; color: #fff; line-height: 18px;">修改</span>
					</span>
				</li>
				<li v-if="is_trans"><span class="label">转入账户</span><span>{{ payment.payment_way }}（{{ payment.hz_bank_account }}）</span></li>
				<li v-if="is_trans && payment.bank_name"><span class="label">付款银行</span><span>{{ payment.bank_name }}</span></li>
				<li v-if="is_trans && payment.bank_account_name"><span class="label">付款账户</span><span>{{ payment.bank_account_name }}</span></li>
				<li v-if="has_trade_no"><span class="label">付款单号</span><span>{{ payment.trade_no }}</span></li>
				<li v-if="has_alipayid"><span class="label">付款账号</span><span>{{ payment.alipay_id }}</span></li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OrderPayItem',
	props: ['payment', 'role', 'last'],
	data: () => ({
	}),
	mounted: function () {
	},
	computed: {
		is_online () {
			return this.payment.is_online
		},
		is_trans () {
			return this.payment.is_trans
		},
		allowEdit () {
			return this.payment.is_trans && this.payment.pay_status === 11
		},
		has_trade_no () {
			return this.payment.trade_no
		},
		has_alipayid () {
			return this.payment.is_trans && this.payment.alipay_id
		},
		paid_time () {
			return this.payment.paid_time.substring(0, 10)
		},
		payStatusClass () {
			// 付款状态文字颜色
			const status = this.payment.pay_status
			if (status === 11 || status === 60) return 'yellow'
			if (status === 30) return 'green'
			if (status === 70) return 'red'
			return 'yellow'
		}
	},
	methods: {
		toEdit () {
			if (this.payment.is_trans) {
				if (this.payment.is_edit) {
					this.$store.dispatch('setPayment', {'payment': this.payment})
					this.$router.push('/trans/edit')
				}
			}
		}
	}
}
</script>

<style scoped>
.yellow { color: #ff8a05; }
.green { color: #14A85F; }
.red { color: #FA3D41; }
</style>



// WEBPACK FOOTER //
// OrderPayItem.vue?1743621a